import { TYPES } from "./types";
import { tkt1C3DInfoService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getTKT1C3DInfos = (query) => async (dispatch) => {
  try {
    const result = await tkt1C3DInfoService.getC3DInfos(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_C3D_INFOS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_C3D_INFOS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1C3DInfoByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1C3DInfoService.getC3DInfoByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_C3D_INFO_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_C3D_INFO_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1C3DInfo = (c3dInfoData) => async (dispatch) => {
  try {
    const result = await tkt1C3DInfoService.createC3DInfo(c3dInfoData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_C3D_INFO_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_C3D_INFO_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1C3DInfo = (id, c3dInfoData) => async (dispatch) => {
  try {
    const result = await tkt1C3DInfoService.updateC3DInfo(id, c3dInfoData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_C3D_INFO_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_C3D_INFO_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1C3DInfo = (id) => async (dispatch) => {
  try {
    const result = await tkt1C3DInfoService.deleteC3DInfo(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_C3D_INFO_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_C3D_INFO_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1C3DInfoAction = {
  getTKT1C3DInfos,
  getTKT1C3DInfoByID,
  createTKT1C3DInfo,
  updateTKT1C3DInfo,
  deleteTKT1C3DInfo
};
